import React, { useEffect, useState, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Slider from "react-slick";
import { BASE_URL } from './Config/Config';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SubLoading from './ALL CSS/Loading';
import styled from 'styled-components';
import { UseGlobelcourse } from './component/allcoursecontaxt/ALLCoursecontaxt';

function Contact() {
  const [categorydata, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const sliderRef = useRef(); // <-- this controls the carousel
  const {dispatch} = UseGlobelcourse();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${BASE_URL}/coursecategory/`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include"
        });
        const result = await res.json();
        setCategoryData(result.data || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };
    const handleCategoryClick = (category_name)=>{
dispatch({
    type: 'UPDATE_FILTER_VALUE',
    payload: { name: 'categoryname', value:category_name },
  });
  }

  return (
    <div className="space-top arrow-wrap" id="target-section">
      <div className="container">
        <div className="category-sec-wrap">
          <div className="shape-mockup category-shape-arrow d-xl-block d-none">
            <img src="/assets/img/normal/category-arrow.svg" alt=" Auratech course category" />
          </div>
          <div className="row">

            <div className="col-xl-4">
              <div className="title-area mb-25 mb-lg-0 text-xl-start text-center">
                <span className="sub-title">
                  <i className="fal fa-book me-2" /> Courses Categories
                </span>
                <h2 className="sec-title">Explore Top Categories</h2>
                <NavLink to="/course" className="th-btn">
                  View All Category <i className="fa-regular fa-arrow-right ms-2" />
                </NavLink>
              </div>
            </div>


            <div className="col-xl-8 ">
              <div className="d-flex align-items-center justify-content-between " style={{ position: 'relative' }}>
                {/* Left side content (if any), or keep empty */}
                <div className="ms-auto d-flex gap-2">
               <Wrapper>
                  <button
                    className="custom-slider-button custom-next "
                    onClick={() => sliderRef.current?.slickPrev()}
                  >
                    <i className="fa-regular fa-arrow-right" style={{ transform: 'rotate(180deg)' }} />
                  </button>
                  <button
                    className="custom-slider-button custom-next"
                    onClick={() => sliderRef.current?.slickNext()}
                  >
                    <i className="fa-regular fa-arrow-right" />
                  </button>
                </Wrapper>
                </div>
              </div>


              <div className="row slider-shadow th-carousel category-slider slick-initialized slick-slider">
                <div className='slick-list draggable'>
                  <div className='slick-track'>
                    {loading ? (
                      <SubLoading />
                    ) : (
                      <Slider ref={sliderRef} {...sliderSettings}>
                        {categorydata.map((data, index) => (
                          <div key={index} className="col-lg-4 col-xl-4 col-md-8 px-2 ">
                            <Link to="/course#target-section" style={{ textDecoration: "none", color: "black" }}>
                              <div className="category-list "style={{ width: "100%" }} >

                                <div className="category-list_icon">

                                  <img
                                    src={data?.category_icon ? `${BASE_URL}${data?.category_icon}` : "/assets/img/icon/category_3_1.svg"}
                                    alt={data.category_name}
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                  />
                                </div>

                                <div className="category-list_content">
                                  <h3 className="category-list_title" title={data.category_name} 
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    marginBottom: "0.25rem",
                                  }}
                                      onClick={() => handleCategoryClick(data.category_name)}

                                  >
                                    {data.category_name}
                     
                                  </h3>

                                  <span className="category-list_text">
                                    {data.item_stock_value} Courses
                                  </span>

                                  <NavLink to="/course#target-section" className="icon-btn">
                                    <i className="fas fa-arrow-right" />
                                  </NavLink>
                                </div>
                              </div>
                            </Link>
                          </div>
                        ))}
                      </Slider>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


const Wrapper = styled.section`
.custom-next {
  width: 40px;
  height: 30px;
  border-radius: 10px;
  background: #e9ecf0fc;
  color: var(--theme-color);
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  margin-left:3px
}

.custom-slider-button:hover {
  background: var(--theme-color);
  color: var(--white-color);
}

.custom-prev {
  width: 40px;
  height: 30px;
  border-radius: 10px;
  background: #e9ecf0fc;
  color: var(--theme-color);
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.costom:hover {
  background: var(--theme-color);
  color: var(--white-color);
}

`;
export default Contact;
